import { environmentName, zapierURL } from "../api/config";

/**
 * Rewrite URLs when on localhost to fix next/previous URLs for aperture proxy
 * based development, for developers not running a local monolith
 *
 * https://gitlab.com/zapier/aperture
 */
export function apertureRewriteURL(url: string): string {
  if (environmentName !== "local") {
    return url;
  }
  const zapier = new URL(zapierURL);
  const local = new URL(url);
  local.host = zapier.host;
  local.protocol = zapier.protocol;
  return local.href;
}
